import {EMPTY_ARRAY, IApplicationState} from '../../../../../../../types/types';
import { ITemplate } from '../types';

export const getTemplatesList = (
    state: IApplicationState
): ITemplate[] => {
    return state.openBoardsDialog && state.openBoardsDialog.templates && state.openBoardsDialog.templates.templates || EMPTY_ARRAY;
};
